var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.emails),function(item,key){return _c('email-item',{key:key,attrs:{"itemIndex":key,"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }